import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "flex flex-col h-full xl:flex-row" }
const _hoisted_2 = { class: "border-b border-white flex flex-col justify-evenly xl:w-2/5" }
const _hoisted_3 = { class: "flex flex-row items-center" }
const _hoisted_4 = { class: "grid info-circle" }
const _hoisted_5 = { class: "font-bold pl-5" }
const _hoisted_6 = { class: "w-full" }
const _hoisted_7 = { class: "font-raleway bg-blue-600 text-white p-3" }
const _hoisted_8 = { class: "w-full" }
const _hoisted_9 = { class: "font-raleway bg-blue-600 text-white p-3" }
const _hoisted_10 = { class: "w-full" }
const _hoisted_11 = { class: "font-raleway bg-blue-600 text-white p-3" }
const _hoisted_12 = { class: "w-full" }
const _hoisted_13 = { class: "font-raleway bg-blue-600 text-white p-3" }
const _hoisted_14 = { class: "w-full" }
const _hoisted_15 = { class: "font-raleway bg-blue-600 text-white p-3" }
const _hoisted_16 = { class: "border-t border-b border-white w-full pt-5 pb-5 pl-5 hidden place-items-center xl:grid" }
const _hoisted_17 = { class: "pr-5 overflow-auto blueScroll" }
const _hoisted_18 = { class: "mb-3 w-full xl:w-2/3" }
const _hoisted_19 = { class: "font-raleway bg-blue-600 text-white p-3" }
const _hoisted_20 = { class: "mb-3 w-full xl:w-2/3" }
const _hoisted_21 = { class: "font-raleway bg-blue-600 text-white p-3" }
const _hoisted_22 = { class: "mb-3 w-full xl:w-2/3" }
const _hoisted_23 = { class: "font-raleway bg-blue-600 text-white p-3" }
const _hoisted_24 = { class: "mb-3 w-full xl:w-2/3" }
const _hoisted_25 = { class: "font-raleway bg-blue-600 text-white p-3" }
const _hoisted_26 = { class: "mt-3 w-full xl:w-2/3" }
const _hoisted_27 = { class: "font-raleway bg-blue-600 text-white p-3" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_plusMinus = _resolveComponent("plusMinus")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.ans, (a, index) => {
        return (_openBlock(), _createBlock("div", {
          key: index,
          class: ["border-white border-t flex-1 grid px-2 z-10 place-items-center xl:py-2", {
          'info-grey-block text-sm py-3 xl:border-r': a.text !== _ctx.selected.text,
          'info-colour-block text-base py-6': a.text === _ctx.selected.text,
          'border-t': index === 0 && a.text === _ctx.selected.text,
        }]
        }, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("i", {
                class: `info-icon text-brand-darkBlue fas fa-${_ctx.ans[index].icon}`
              }, null, 2)
            ]),
            _createVNode("div", _hoisted_5, _toDisplayString(_ctx.ans[index].text), 1)
          ]),
          _createVNode("div", {
            class: ["border-white mt-5 mb-5 px-5 overflow-auto blueScroll info-box block xl:border-t xl:border-l xl:border-b xl:mr-5 xl:w-20 xl:hidden", {
            hidden: _ctx.ans[index].text !== _ctx.selected.text,
          }]
          }, [
            _createVNode("div", _hoisted_6, [
              _createVNode(_component_plusMinus, {
                score: _ctx.ans[index].carbonFootprint,
                title: "Carbon Footprint"
              }, null, 8, ["score"])
            ]),
            _createVNode("p", _hoisted_7, _toDisplayString(_ctx.selected.carbonFootprintCopy), 1),
            _createVNode("div", _hoisted_8, [
              _createVNode(_component_plusMinus, {
                score: _ctx.ans[index].economicProsperity,
                title: "Economic Prosperity"
              }, null, 8, ["score"])
            ]),
            _createVNode("p", _hoisted_9, _toDisplayString(_ctx.selected.economicProsperityCopy), 1),
            _createVNode("div", _hoisted_10, [
              _createVNode(_component_plusMinus, {
                score: _ctx.ans[index].employment,
                title: "Employment"
              }, null, 8, ["score"])
            ]),
            _createVNode("p", _hoisted_11, _toDisplayString(_ctx.selected.employmentCopy), 1),
            _createVNode("div", _hoisted_12, [
              _createVNode(_component_plusMinus, {
                score: _ctx.ans[index].healthHappinessAndWellbeing,
                title: "Health, Happiness & Wellbeing"
              }, null, 8, ["score"])
            ]),
            _createVNode("p", _hoisted_13, _toDisplayString(_ctx.selected.healthHappinessAndWellbeingCopy), 1),
            _createVNode("div", _hoisted_14, [
              _createVNode(_component_plusMinus, {
                score: _ctx.ans[index].wildlife,
                title: "Wildlife"
              }, null, 8, ["score"])
            ]),
            _createVNode("p", _hoisted_15, _toDisplayString(_ctx.selected.wildlifeCopy), 1)
          ], 2)
        ], 2))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _createVNode("div", _hoisted_16, [
      _createVNode("div", _hoisted_17, [
        _createVNode("div", _hoisted_18, [
          _createVNode(_component_plusMinus, {
            score: _ctx.selected.carbonFootprint,
            title: "Carbon Footprint"
          }, null, 8, ["score"])
        ]),
        _createVNode("p", _hoisted_19, _toDisplayString(_ctx.selected.carbonFootprintCopy), 1),
        _createVNode("div", _hoisted_20, [
          _createVNode(_component_plusMinus, {
            score: _ctx.selected.economicProsperity,
            title: "Economic Prosperity"
          }, null, 8, ["score"])
        ]),
        _createVNode("p", _hoisted_21, _toDisplayString(_ctx.selected.economicProsperityCopy), 1),
        _createVNode("div", _hoisted_22, [
          _createVNode(_component_plusMinus, {
            score: _ctx.selected.employment,
            title: "Employment"
          }, null, 8, ["score"])
        ]),
        _createVNode("p", _hoisted_23, _toDisplayString(_ctx.selected.employmentCopy), 1),
        _createVNode("div", _hoisted_24, [
          _createVNode(_component_plusMinus, {
            score: _ctx.selected.healthHappinessAndWellbeing,
            title: "Health, Happiness and Wellbeing"
          }, null, 8, ["score"])
        ]),
        _createVNode("p", _hoisted_25, _toDisplayString(_ctx.selected.healthHappinessAndWellbeingCopy), 1),
        _createVNode("div", _hoisted_26, [
          _createVNode(_component_plusMinus, {
            score: _ctx.selected.wildlife,
            title: "Wildlife"
          }, null, 8, ["score"])
        ]),
        _createVNode("p", _hoisted_27, _toDisplayString(_ctx.selected.wildlifeCopy), 1)
      ])
    ])
  ]))
}